const parseTimeFormat = (input: string) => {
	const [hours, minutes, seconds] = input
		.split(':')
		.map((item) => parseInt(item));

	return hours * 3600 + minutes * 60 + seconds;
};

export default parseTimeFormat;
